const STORAGE_KEY = 'bps.openTabs.v1';

export const readTabPaths = () => {
  try {
    const paths = JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    return Array.isArray(paths) ? paths.filter(path =>
      typeof path === 'string' && path.startsWith('/') && !path.startsWith('//') &&
      !['/', '/login', '/logout'].includes(path.toLowerCase())
    ) : [];
  } catch {
    return [];
  }
};

export const saveTabPaths = (tabs) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tabs.map(tab => tab.path)));
  } catch {
    // Tabs remain usable when browser storage is unavailable or full.
  }
};

export const clearTabSession = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Storage may be disabled by browser settings.
  }
};
